import Vue from "vue";
import availableSymbols from "./symbols";
import EventBus from "../../shared/utils/event_bus.js";
import { ConvertTimeframe } from "./utils";

const vm = new Vue();

const lastBarsCache = new Map();
const channelToSubscription = new Map();

let myChart = {};
let investmentId; //é usado na api de markers
let lastContextChart = []; //armazena os contextos dos cards
let storageUnsubscribe = []; //é armazenado todos que devem ser removidos no unsubscribe

/**
 * Debug - mostrar na tela a variável channelToSubscription
 */
EventBus.$on("SHOW_CHANNEL_SUBSCRIPTION", () => {
  const style = "background:#5b21b6;padding:4px;font-weight:bold;color:white;";
  const style2 = "color:#c026d3;padding:4px;font-weight:bold;";
  console.clear();
  console.log("%c💣💣💣💣💣💣💣💣", "font-size:28px;");
  console.log("💣 %c@[channelToSubscription]", style, channelToSubscription);
  console.log("💣 %c@[storageUnsubscribe]", style, storageUnsubscribe);
  console.log("💣 %c@[myChart]", style, myChart);

  Array.from(channelToSubscription.keys(), (value) => value).forEach((keyChannel) => {
    console.log("%c---", style2);
    const item = channelToSubscription.get(keyChannel);
    console.log(keyChannel, item);
    item.handlers.forEach((handler) => console.log("[handler]", handler));
  });
  console.log("%c💣💣💣💣💣💣💣💣", "font-size:28px;");

  EventBus.$emit("RESTART_CONSUMER", false);
});

EventBus.$on("DATAFEED_REMOVE_CONTEXTUUID", (contextUuid) => {
  lastContextChart = [];

  const { symbol, timeframe } = myChart[contextUuid];
  const channelString = `MD.${symbol}.${timeframe}`;
  const item = channelToSubscription.get(channelString);
  if (item) {
    item.handlers = item.handlers.filter((item2) => item2.id != contextUuid);
    if (item.handlers.length === 0) {
      channelToSubscription.delete(channelString);
    }
  }
  myChart = Object.values(myChart).filter((item) => item.id != contextUuid);

  const filteredItems = Object.values(myChart).filter((item) => item.id != contextUuid);

  let newObj = {};
  Object.keys(filteredItems).forEach((key) => (newObj[filteredItems[key].id] = filteredItems[key]));
  myChart = newObj;
});

EventBus.$on("DATAFEED_RESET_CACHE_TO_UPDATE_HISTORICAL_DATA", ({ symbol, timeframe, contextUuid }) => {
  const channelString = `MD.${symbol}.${timeframe}`;

  lastContextChart = lastContextChart.filter((item) => item != `${contextUuid}:${symbol}:${timeframe}`);
  storageUnsubscribe = [];

  const item = channelToSubscription.get(channelString);
  if (item) {
    item.handlers.forEach((handler) => {
      if (handler.id === contextUuid) {
        if (handler.onResetCacheNeededCallback) {
          handler.onResetCacheNeededCallback();
        }
      }
    });
  }
});

EventBus.$on("DATAFEED_MAP_CHART", ({ symbol, timeframe, contextUuid }) => {
  lastContextChart.push(contextUuid);

  if (myChart[contextUuid]) {
    const _symbol = myChart[contextUuid].symbol;
    const _timeframe = myChart[contextUuid].timeframe;
    if (_symbol != symbol || _timeframe != timeframe) {
      const hasIndex = storageUnsubscribe.findIndex((item) => item.includes(contextUuid));
      if (hasIndex != -1) {
        storageUnsubscribe.splice(hasIndex, 1);
      }
      storageUnsubscribe.push(`${contextUuid}:${_symbol}:${_timeframe}`);
    }
  }

  myChart[contextUuid] = {
    id: contextUuid,
    symbol,
    timeframe,
  };
});

EventBus.$on("DATAFEED_CHANGE_TIMEFRAME", ({ timeframe, contextUuid }) => {
  if (myChart[contextUuid]) {
    const _symbol = myChart[contextUuid].symbol;
    const _timeframe = myChart[contextUuid].timeframe;
    if (_timeframe != timeframe) {
      if (!storageUnsubscribe.includes(`${contextUuid}:${_symbol}:${_timeframe}`)) {
        storageUnsubscribe.push(`${contextUuid}:${_symbol}:${_timeframe}`);
      }
    }
  }
  myChart[contextUuid].timeframe = timeframe;
});

EventBus.$on("DATAFEED_MARKERS_INVESTMENT_ID", ({ investment_id }) => {
  investmentId = investment_id;
});

const exchanges = availableSymbols.map((symbol) => {
  if (!symbol.includes("FUT")) {
    return {
      value: symbol,
      name: symbol,
      desc: symbol,
    };
  }
  return;
});

const configurationData = {
  supports_search: true,
  supports_group_request: false,
  supports_marks: true,
  supports_timescale_marks: true,
  supports_time: true,
  has_intraday: true,
  has_seconds: true,
  has_ticks: true,
  custom_resolutions: true,
  supported_resolutions: [
    "15S", //S15
    "30S", //S30
    "1", //M1
    "2", //M2
    "3", //M3
    "5", //M5
    "6", //M6
    "10", //M10
    "12", //M12
    "15", //M15
    "30", //M30
    "60", //H1
    "1T", //T1000
  ],
  exchanges: [{ value: "", name: "Todos", desc: "" }, ...exchanges],
  symbols_types: [
    { name: "Todos", value: "" },
    { name: "Ações", value: "stock" },
    { name: "Futuros", value: "futures" },
  ],
};

async function getAllSymbols() {
  return availableSymbols.map((symbol) => {
    return {
      symbol: symbol,
      ticker: symbol,
      full_name: "B3:" + symbol,
      description: symbol,
      exchange: "B3",
      type: symbol.includes("FUT") ? "futures" : "stock",
      // logo_urls: ["https://s3-symbol-logo.tradingview.com/country/BR.svg"],
      // exchange_logo: ["https://s3-symbol-logo.tradingview.com/country/BR.svg"],
    };
  });
}

export default {
  onReady: (callback) => {
    setTimeout(() => callback(configurationData));
  },

  getMarks: async (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
    if (!investmentId || investmentId === 0) {
      onDataCallback([]);
      return;
    }

    const formatStartDate = new Date(startDate * 1000).toISOString().split("T")[0];

    const timeEnd = new Date(endDate * 1000).toISOString().split("T")[0];
    const timeCurrent = new Date().toISOString().split("T")[0];

    EventBus.$emit("DATAFEED_RECEIVE_MARKERS", {
      symbolInfo,
      investmentId,
      startDate: formatStartDate,
      endDate: timeEnd > timeCurrent ? timeEnd : timeCurrent,
    });

    try {
      onDataCallback([]);
    } catch (error) {
      console.log("Error=", error);
    }
  },

  searchSymbols: async (userInput, exchange, symbolType, onResultReadyCallback) => {
    const symbols = await getAllSymbols();
    const newSymbols = symbols.filter((symbol) => {
      const isTypeValid = symbolType === "" || symbol.type === symbolType;
      const isFullSymbolContainsInput = symbol.ticker.toLowerCase().indexOf(userInput.toLowerCase()) !== -1;
      return isTypeValid && isFullSymbolContainsInput;
    });
    onResultReadyCallback(newSymbols);
  },

  resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback, extension) => {
    const symbols = await getAllSymbols();
    const symbolItem = symbols.find((symbol) => symbol.symbol === symbolName);
    if (!symbolItem) {
      onResolveErrorCallback("Cannot resolve symbol");
      return;
    }
    const symbolInfo = {
      ticker: symbolItem.ticker,
      name: symbolItem.symbol,
      description: symbolItem.description,
      type: symbolItem.type,
      // session: "24x7",
      session: symbolItem.type == "crypto" ? "24x7" : symbolItem.type == "futures" ? "0900-1830" : "0900-1800",
      // timezone: "Etc/UTC",
      timezone: "America/Sao_Paulo",
      exchange: symbolItem.exchange,
      minmov: 1,
      pricescale: 100,
      has_intraday: true,
      has_seconds: true,
      has_ticks: true, //se comentar, funciona.
      visible_plots_set: "ohlc",
      has_weekly_and_monthly: false,
      supported_resolutions: configurationData.supported_resolutions,
      volume_precision: 2,
      data_status: "streaming",
      // Logo
      // logo_urls: symbolItem.logo_urls,
      // exchange_logo: symbolItem.exchange_logo,
    };
    onSymbolResolvedCallback(symbolInfo);
  },

  getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
    const { from, to, firstDataRequest } = periodParams;
    try {
      const novaData = new Date(from * 1000);
      novaData.setDate(novaData.getDate() - 10);

      let query = "";
      query += `start_time=${novaData.getTime()}`;
      query += `&end_time=${to * 1000}`;

      const { data } = await vm.$api.get(
        `${vm.$endpoint.GET_BARS_SYMBOL}/${symbolInfo.ticker}/${ConvertTimeframe.toOnTickApi(resolution)}?${query}`
      );
      if (data.length === 0) {
        EventBus.$emit("DATAFEED_RENAME_DISPLAY_TIMEFRAME", {});
        onHistoryCallback([], { noData: true });
        return; // garantir que o onHistoryCallback não seja chamado duas vezes.
      }

      let bars = [];
      data.reverse().forEach((bar) => {
        // if (bar.ts >= from * 1000 && bar.ts < to * 1000) {
        if (bar.ts >= novaData.getTime() && bar.ts < to * 1000) {
          bars = [
            ...bars,
            {
              time: bar.ts,
              low: bar.l,
              high: bar.h,
              open: bar.o,
              close: bar.c,
              volume: bar.v,
            },
          ];
        }
      });

      if (firstDataRequest) {
        lastBarsCache.set(`${symbolInfo.exchange}:${symbolInfo.name}`, {
          ...bars[bars.length - 1],
        });
      }

      onHistoryCallback(bars, { noData: false });
      return; // garantir que o onHistoryCallback não seja chamado duas vezes.
    } catch (error) {
      console.log("[getBars]: Get error", error);
      onErrorCallback(error);
    }

    EventBus.$emit("DATAFEED_RENAME_DISPLAY_TIMEFRAME", {});
    onHistoryCallback([], { noData: true });
  },

  subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
    subscribeOnStream(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscriberUID,
      onResetCacheNeededCallback,
      lastBarsCache.get(`${symbolInfo.exchange}:${symbolInfo.name}`)
    );
  },

  unsubscribeBars: (subscriberUID) => {
    unsubscribeFromStream(subscriberUID);
  },
};

function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscriberUID,
  onResetCacheNeededCallback,
  lastDailyBar
) {
  const channelString = `MD.${symbolInfo.name}.${ConvertTimeframe.toOnTickApi(resolution)}`;

  let handlers = [];

  Object.keys(myChart).forEach((id) => {
    if (myChart[id].symbol === symbolInfo.name && myChart[id].timeframe === ConvertTimeframe.toOnTickApi(resolution)) {
      handlers.push({ id, onResetCacheNeededCallback, callback: onRealtimeCallback });
    }
  });

  const newItem = {
    subscriberUID,
    resolution,
    lastDailyBar,
    handlers: [...handlers],
  };

  const subscriptionItem = channelToSubscription.get(channelString);

  if (subscriptionItem) {
    if (lastContextChart.length > 0) {
      const hasHandlerIndex = subscriptionItem.handlers.findIndex((item) => {
        if (item.id === lastContextChart[0]) {
          // Gráfico atualizado foi?
          return item;
        }
        return;
      });

      if (hasHandlerIndex != -1) {
        // recebe o callback modificado
        subscriptionItem.handlers[hasHandlerIndex].callback = onRealtimeCallback;
        subscriptionItem.handlers[hasHandlerIndex].onResetCacheNeededCallback = onResetCacheNeededCallback;
      } else {
        subscriptionItem.handlers.push({
          id: lastContextChart[0],
          callback: onRealtimeCallback,
          onResetCacheNeededCallback,
        });
      }
    }

    const keysChart = Object.keys(myChart);
    Array.from(channelToSubscription.keys(), (value) => value).forEach((keyChannel) => {
      const itemChannel = channelToSubscription.get(keyChannel);
      if (itemChannel) {
        itemChannel.handlers = itemChannel.handlers.filter((handler) => keysChart.includes(handler.id));
        if (itemChannel.handlers.length === 0) {
          // quer dizer que não tem nenhum handler, então posso excluir a subscrição.
          channelToSubscription.delete(keyChannel);
        }
      }
    });

    lastContextChart.splice(0, 1);

    EventBus.$emit("SUBSCRIBE_CHART", {
      subs: [channelString],
      emptyBars: lastDailyBar === undefined,
    });

    return;
  }

  channelToSubscription.set(channelString, newItem);

  lastContextChart.splice(0, 1);

  const keysChart = Object.keys(myChart);
  Array.from(channelToSubscription.keys(), (value) => value).forEach((keyChannel) => {
    const itemChannel = channelToSubscription.get(keyChannel);
    if (itemChannel) {
      itemChannel.handlers = itemChannel.handlers.filter((handler) => keysChart.includes(handler.id));
      if (itemChannel.handlers.length === 0) {
        // quer dizer que não tem nenhum handler, então posso excluir a subscrição.
        channelToSubscription.delete(keyChannel);
      }
    }
  });

  EventBus.$emit("SUBSCRIBE_CHART", {
    subs: [channelString],
    emptyBars: lastDailyBar === undefined,
  });
}

function unsubscribeFromStream(subscriberUID) {
  Array.from(channelToSubscription.keys(), (value) => value).forEach((keyChannel) => {
    storageUnsubscribe.forEach((keyUnsubscribe, pos) => {
      const [_contextUuid, _symbol, _timeframe] = keyUnsubscribe.split(":");
      if (keyChannel === `MD.${_symbol}.${_timeframe}`) {
        const item = channelToSubscription.get(keyChannel);
        if (item) {
          item.handlers = item.handlers.filter((item2) => item2.id != _contextUuid);

          if (item.handlers.length === 0) {
            channelToSubscription.delete(keyChannel);
            storageUnsubscribe.splice(pos, 1);
          }
        }
      }
    });
  });
}

EventBus.$on("DATAFEED_REALTIME_TICKER_CHART", (payload) => {
  const {
    symbol,
    data: { time, open, high, low, close, trades, volume },
    timeframe,
    contextUuid,
    styleDebugColor,
  } = payload;
  const channelString = `MD.${symbol}.${timeframe}`;
  const subscriptionItem = channelToSubscription.get(channelString);

  if (subscriptionItem === undefined) {
    return;
  }

  if (myChart[contextUuid] && myChart[contextUuid].symbol === symbol && myChart[contextUuid].timeframe === timeframe) {
    subscriptionItem.handlers.forEach((handler) =>
      handler.callback({
        time,
        open,
        high,
        low,
        close,
        volume,
      })
    );
  }
});
